// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PlanChecksRouteImport } from './routes/plan-checks'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as CheckoutPlanIdRouteImport } from './routes/checkout/$planId'
import { Route as AuthPostSigninRouteImport } from './routes/auth/post-signin'
import { Route as PlanChecksRunIdRouteImport } from './routes/plan-checks.$runId'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTeamRouteImport } from './routes/dashboard/team'
import { Route as DashboardSubscriptionRouteImport } from './routes/dashboard/subscription'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardPlansRouteImport } from './routes/dashboard/plans'
import { Route as DashboardHomeRouteImport } from './routes/dashboard/home'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUploadRouteImport } from './routes/admin/upload'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as AdminOverridesRouteImport } from './routes/admin/overrides'
import { Route as AdminImpersonateConversationRouteImport } from './routes/admin/impersonate-conversation'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminConversationsRouteImport } from './routes/admin/conversations'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users.index'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations.index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users.$userId'
import { Route as AdminOrganizationsOrgIdRouteImport } from './routes/admin/organizations.$orgId'
import { Route as AdminDocumentsDocumentIdRevisionsRevisionIdRouteImport } from './routes/admin/documents.$documentId.revisions.$revisionId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PlanChecksRoute = PlanChecksRouteImport.update({
            id: '/plan-checks',path: '/plan-checks',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ChatRoute = ChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
            id: '/accept-invitation',path: '/accept-invitation',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const CheckoutPlanIdRoute = CheckoutPlanIdRouteImport.update({
            id: '/checkout/$planId',path: '/checkout/$planId',getParentRoute: () => rootRouteImport
          })
const AuthPostSigninRoute = AuthPostSigninRouteImport.update({
            id: '/auth/post-signin',path: '/auth/post-signin',getParentRoute: () => rootRouteImport
          })
const PlanChecksRunIdRoute = PlanChecksRunIdRouteImport.update({
            id: '/$runId',path: '/$runId',getParentRoute: () => PlanChecksRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardTeamRoute = DashboardTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => DashboardRoute
          })
const DashboardSubscriptionRoute = DashboardSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => DashboardRoute
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRoute
          })
const DashboardPlansRoute = DashboardPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => DashboardRoute
          })
const DashboardHomeRoute = DashboardHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => DashboardRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUploadRoute = AdminUploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => AdminRoute
          })
const AdminPlansRoute = AdminPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AdminRoute
          })
const AdminOverridesRoute = AdminOverridesRouteImport.update({
            id: '/overrides',path: '/overrides',getParentRoute: () => AdminRoute
          })
const AdminImpersonateConversationRoute = AdminImpersonateConversationRouteImport.update({
            id: '/impersonate-conversation',path: '/impersonate-conversation',getParentRoute: () => AdminRoute
          })
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => AdminRoute
          })
const AdminConversationsRoute = AdminConversationsRouteImport.update({
            id: '/conversations',path: '/conversations',getParentRoute: () => AdminRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
            id: '/organizations/',path: '/organizations/',getParentRoute: () => AdminRoute
          })
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
            id: '/users/$userId',path: '/users/$userId',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsOrgIdRoute = AdminOrganizationsOrgIdRouteImport.update({
            id: '/organizations/$orgId',path: '/organizations/$orgId',getParentRoute: () => AdminRoute
          })
const AdminDocumentsDocumentIdRevisionsRevisionIdRoute = AdminDocumentsDocumentIdRevisionsRevisionIdRouteImport.update({
            id: '/documents/$documentId/revisions/$revisionId',path: '/documents/$documentId/revisions/$revisionId',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminConversationsRoute: AdminConversationsRoute,AdminFeedbackRoute: AdminFeedbackRoute,AdminImpersonateConversationRoute: AdminImpersonateConversationRoute,AdminOverridesRoute: AdminOverridesRoute,AdminPlansRoute: AdminPlansRoute,AdminUploadRoute: AdminUploadRoute,AdminIndexRoute: AdminIndexRoute,AdminOrganizationsOrgIdRoute: AdminOrganizationsOrgIdRoute,AdminUsersUserIdRoute: AdminUsersUserIdRoute,AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute,AdminDocumentsDocumentIdRevisionsRevisionIdRoute: AdminDocumentsDocumentIdRevisionsRevisionIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const DashboardRouteChildren = {
  DashboardHomeRoute: DashboardHomeRoute,DashboardPlansRoute: DashboardPlansRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardSubscriptionRoute: DashboardSubscriptionRoute,DashboardTeamRoute: DashboardTeamRoute,DashboardIndexRoute: DashboardIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const PlanChecksRouteChildren = {
  PlanChecksRunIdRoute: PlanChecksRunIdRoute
}

const PlanChecksRouteWithChildren = PlanChecksRoute._addFileChildren(PlanChecksRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AcceptInvitationRoute: AcceptInvitationRoute,AdminRoute: AdminRouteWithChildren,ChatRoute: ChatRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRouteWithChildren,LoginRoute: LoginRoute,PlanChecksRoute: PlanChecksRouteWithChildren,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SettingsRoute: SettingsRoute,TermsRoute: TermsRoute,AuthPostSigninRoute: AuthPostSigninRoute,CheckoutPlanIdRoute: CheckoutPlanIdRoute,CheckoutSuccessRoute: CheckoutSuccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)